<div id="cookiePolicy">
  <div class="margin-bottom">
    <span id="cookieTitle">{{ 'uix.cookiesPolicy.title' | translate }}</span>
    <span id="cookieClose" class="pull-right pointer" (click)="onAccept()">&times;</span>
  </div>
  <div>
    <div id="cookieMessage">
      <span>{{ 'uix.cookiesPolicy.message' | translate }}</span>
    </div>
    <div>
      <button id="cookieButton" mat-raised-button color="primary" (click)="onAccept()" class="pull-right">{{ 'uix.cookiesPolicy.accept' | translate }}</button>
    </div>
  </div>
</div>
